"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TryFileUploadSchema = exports.TryCreateUrlReadSchema = void 0;
var tryCreateUrlReadSchema_1 = require("./tryCreateUrlReadSchema");
Object.defineProperty(exports, "TryCreateUrlReadSchema", { enumerable: true, get: function () { return __importDefault(tryCreateUrlReadSchema_1).default; } });
var tryFileUploadSchema_1 = require("./tryFileUploadSchema");
Object.defineProperty(exports, "TryFileUploadSchema", { enumerable: true, get: function () { return __importDefault(tryFileUploadSchema_1).default; } });
